import React, { Component } from 'react'
import PropTypes from 'prop-types';
import { Upload, Modal } from 'antd';
import {_imageSave}  from './EditorMedia/actions';
import { LoadingOutlined, PlusOutlined } from '@ant-design/icons';
import classNames from 'classnames';
import './UploadImageField.scss';
import { toastr } from 'react-redux-toastr';

const upload = (file, cb = () => {}) => {
  var url = '/mcq1/upload-img'
  var xhr = new XMLHttpRequest()

  var formData = new FormData()
  xhr.responseType = 'json';
  xhr.open('POST', url, true);
  if (localStorage.getItem('token')) {
    xhr.setRequestHeader('Authorization', 'Bearer '+ localStorage.getItem('token'))
  }
  
  if (sessionStorage.getItem('token')) {
    xhr.setRequestHeader('Authorization', 'Bearer '+ localStorage.getItem('token'))
  }
  xhr.upload.addEventListener("progress", function(e) {
    // if(!status){
    //   setStatus(true)
    // }
    // setProgress( (e.loaded * 100.0 / e.total) || 100)
  }); 
  

  xhr.onload = xhr.onerror = function() {
    if (this.status == 200) {
      // if(!status){
        // setStatus(true)
      // }
      // setDone(true);
      if(cb){
        cb(xhr.response)
      }
    } else {
      // if(!status){
      //   setStatus(true)
      // }
      // setDone(false);
      if(cb){
        cb(xhr.response)
      }
    }
  };

  
  formData.append('file', file)
  xhr.send(formData)
}


class UploadImageField extends React.Component {
  static contextTypes = {formatMessage: PropTypes.any};
  state = {
    previewVisible: false,
    loading: false,
  };


  handleImageChange = (e) => {
    const {formatMessage} = this.context;
    const {loading} = this.state;    
    const {input} = this.props;
    const file = e.target.files[0];
    if(loading){
      return;
    }
    console.log("🚀 ~ file: UploadVideoField.jsx ~ line 61 ~ handleFiles ~ file.type", file.type)
    
    if(!['image/jpeg', 'image/png'].includes(file.type)){
      toastr.error(formatMessage('errImgUploadType'), formatMessage('msgErrImgUploadType'))
      return;
    }

    if(file.size > 3 * 1024 * 1024){
      toastr.error(formatMessage('errImgUploadSize'), formatMessage('msgErrImgUploadSize'))
      return;
    }
    this.setState({loading: true})
    let reader = new FileReader();
    reader.onloadend = () => {

      _imageSave({file}).then(res => {
        console.log("🚀 ~ file: UploadImageField.jsx ~ line 91 ~ UploadImageField ~ _imageSave ~ res", res)
        this.setState({loading: false})
        if(res && res.uploadedImg){
          input.onChange(res.uploadedImg);
        } else {
          // error
          toastr.error(formatMessage('errImgUpload'), formatMessage('msgImgVideoUpload'))
        }
      })
      // upload(file, (res) => {
      //   this.setState({loading: false})

     

      // });
      
      this.setState({
        file: file,
        imagePreviewUrl: reader.result
      });
    }

    reader.readAsDataURL(file)
  }

  render() {
    const {input: {value, name, onChange}, meta: {error, touched}, label, className} = this.props;
    const {formatMessage} = this.context;
    const {previewVisible, loading} = this.state;

    return (
      <div className={classNames('UploadImageField', className)}>
        {label && <label htmlFor={"nf-" + name}>{label}</label>}
        <Modal
          title={formatMessage('Preview')}
          centered
          visible={previewVisible}
          width="80%"
          zIndex={9999999}
          footer={false}
          // maskClosable={false}
          onCancel={() => {
            this.setState({previewVisible: false})
          }}
        >
          <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
            <img style={{maxWidth: '100%'}} src={value} />
          </div>
        </Modal>

        {!value && <label className="upload-img">
          {loading ? <LoadingOutlined /> : <PlusOutlined  />}
          <div style={{ marginTop: 8 }}>Upload</div>
          <input type="file" style={{display: 'none'}}  onChange={this.handleImageChange} />
        </label>}
        {value && <div className="preview-img">
          <div className="block">
            <button className="btn btn-info btn-sm" type="button" style={{marginRight: 5}} onClick={() => {this.setState({previewVisible: true})}}>
              <i className="fas fa-eye"></i>
            </button>
            <label className="btn btn-secondary btn-sm" type="button" style={{marginRight: 5}}>
              <i className="fas fa-edit"></i>
              <input type="file" style={{display: 'none'}}  onChange={this.handleImageChange} />
            </label>
            <button className="btn btn-danger btn-sm" type="button" onClick={() => {onChange('')}}>
              <i className="fas fa-trash"></i>
            </button>
          </div>
          <img style={{maxWidth: '100%'}} src={value} />
        </div>}
        {touched && ((error && <div className="help-block">{error}</div>))}
      </div>
    );
  }
}

export default UploadImageField


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/helpers/Fields/UploadImageField.jsx